import React from "react";
import { Row, Col, Table, Button, Modal, Form } from "react-bootstrap";
import { useState, useEffect } from 'react';
import axios from 'axios';
import config from "../../config";
import { toast } from "react-toastify";
import PackingMaterialDetailsCard from "./PackingMaterialDetailsCard";
import TemporaryAllocationModal from '../operationalDashboard/TemporaryAllocationModal';

export default function SODetailsTab({ order, items, onChange }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [packingMaterials, setPackingMaterials] = useState([]);

  const [showAllocationModal, setShowAllocationModal] = useState(false);
  const [
    // allocationRefreshTrigger, 
    setAllocationRefreshTrigger
  ] = useState(0);
  const [
    selectedStockItem,
    //  setSelectedStockItem
  ] = useState(null);

  const [
    // stockSummary, 
    setStockSummary
  ] = useState([]);


  // Fetch packing materials
  useEffect(() => {
    const fetchPackingMaterials = async () => {
      try {
        const res = await axios.get(`${config.API_BASE_URL}/packing-materials`);
        setPackingMaterials(res.data);
      } catch (err) {
        console.error('Error fetching packing materials:', err);
      }
    };

    if (items && items.length > 0) {
      fetchPackingMaterials();
    }
  }, [items]);
  useEffect(() => {
    const fetchProductStock = async () => {
      try {
        const stockResponse = await axios.get(`${config.API_BASE_URL}/inventory/stock-overview`);
        if (stockResponse.data) {
          setStockSummary(stockResponse.data.products || []);
        }
      } catch (err) {
        console.error('Error fetching stock summery:', err);
      }
    };
    fetchProductStock();
  }, []);


  if (!order) return null;
  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('orderId', order._id);

    try {
      await axios.post(`${config.API_BASE_URL}/sales-orders/upload-po`, formData);
      toast.success('PO uploaded successfully!');
      setShowModal(false);
      onChange();
      // Optionally trigger a refresh here
    } catch (err) {
      toast.error('Upload failed');
    }
  };

  // const handleShowAllocationModal = (item) => {
  //   // Enrich item with stock data from stockSummary
  //   const productStock = stockSummary.find(s => s.product._id === item.product._id);
  //   const enrichedItem = {
  //     ...item,
  //     product: {
  //       ...item.product,
  //       totalAvailableStock: productStock?.totalAvailableStock || 0
  //     }
  //   };
  //   setSelectedStockItem(enrichedItem);
  //   setShowAllocationModal(true);
  // };

  const handleAllocationSaved = () => {
    setAllocationRefreshTrigger(prev => prev + 1);
  };

  // const subtotal = items.reduce((sum, it) => sum + (it.orderedQuantity * it.rate), 0);
  // const taxAmount = subtotal * ((parseFloat(order.tax) || 0) / 100);
  // const grandTotal = subtotal + taxAmount;

  return (
    <>
      <Row className="mb-2">
        {/* Order Information Section */}
        <Col md={6} className="order-details">
          {/* <h4>Order Details</h4> */}
          <p><strong>Order Date:</strong> {new Date(order.orderDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</p>
          <p><strong>Expected Delivery:</strong> {new Date(order.EDD).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</p>
          <p><strong>Buyer PO Number:</strong> {order.buyerPONumber}</p>
          <p>
            <strong>Buyer PO Attachment:</strong>{' '}
            {order.buyerPOAttachment ? (
              <>
                <a href={config.DOC_BASE_URL + order.buyerPOAttachment} target="_blank" rel="noreferrer">View</a>
                {' | '}
              </>
            ) : (
              'No file uploaded | '
            )}
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => setShowModal(true)}
            >
              {order.buyerPOAttachment ? 'Change' : 'Upload'}
            </Button>
          </p>
        </Col>
        {/* Additional Order Information Section */}
        <Col md={6} className="additional-info">
          {/* <h4>Order Terms & Notes</h4> */}
          <p><strong>Payment Terms:</strong> {order.paymentTerm}</p>
          <p><strong>Delivery Term:</strong> {order.deliveryTerms}</p>
          <p><strong>Lab Test Required:</strong> {order.labTestRequired ? "Yes" : "No"}</p>
          <p><strong>Notes:</strong> {order.remarks}</p>
        </Col>
      </Row>

      <hr />

      <Row className="mb-5">
        {/* Billing Information Section */}
        <Col md={6} className="billing-info">
          <h4>Billing Information</h4>
          {/* <p><strong>Buyer:</strong> {order.buyerBillTo.name}</p>
          <p><strong>Address:</strong></p> */}
          {
            order.buyerBillTo?.address.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))
          }
        </Col>
        {/* Delivery Information Section */}
        <Col md={6} className="delivery-info">
          <h4>
            Delivery Information{" "}
            {!order.sameAsBillingAddress && (
              <span className="badge text-bg-warning">
                Different from Billing
              </span>
            )}
          </h4>
          {/* <p><strong>Recipient:</strong> {order.buyerDeliveryDetails.name}</p>
          <p><strong>Address:</strong></p> */}
          {
            order.buyerDeliveryDetails?.address.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))
          }
        </Col>


      </Row>


      {/* Ordered Items Section */}
      <Table bordered responsive striped hover>
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Product</th>
            <th>Quality</th>
            <th>Weight</th>
            <th>Packing Bag Type</th>
            <th>Custom Marking</th>
            <th>Weight Type</th>
            <th>Unit Price (₹)</th>
            <th>Base Amount (₹)</th>
            <th>Tax (%)</th>
            <th>Tax Amount (₹)</th>
            <th>Total (₹)</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it, idx) => {
            // const selectedMaterial = packingMaterials.find((m) => m._id === it.packingBagType._id);
            return (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{it.product?.productName}</td>
                <td>{it.quality}</td>
                <td>{it.quantity} {it.unit}</td>
                <td>
                  {it.packingBagType ?
                    `${it.packingBagType.name} (${it.packingBagType.itemWiseStuffing?.find(s => s.product._id.toString() === it.product?._id?.toString())?.quantity || 0} ${it.unit}/bag)` :
                    '-'
                  }
                  {/* {selectedMaterial ?
                    `${selectedMaterial.name} (${selectedMaterial.itemWiseStuffing?.find(s => s.product.toString() === it.product?._id?.toString())?.quantity || 0} ${it.unit} per bag)` :
                    '-'
                  } */}
                </td>
                <td>{it.customMarking || '-'}</td>
                <td>{it.grossOrNet}</td>
                <td>{it.unitPrice ? Number(it.unitPrice).toFixed(2) : '0.00'}</td>
                <td>{it.baseAmount ? Number(it.baseAmount).toFixed(2) : '0.00'}</td>
                <td>{it.tax}</td>
                <td>{it.taxAmount ? Number(it.taxAmount).toFixed(2) : '0.00'}</td>
                <td>{it.totalPrice ? Number(it.totalPrice).toFixed(2) : '0.00'}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {/* Order Summary Section */}
      <div className="order-summary text-end">
        <Table responsive className="table-sm w-auto float-end" bordered={false}>
          <tbody>
            <tr>
              <td className="pe-3"><strong>Tax:</strong></td>
              <td className="text-end">₹{order.taxAmount ? Number(order.taxAmount).toFixed(2) : '0.00'}</td>
            </tr>
            {order.transportation && (
              <tr>
                <td className="pe-3"><strong>Transportation:</strong></td>
                <td className="text-end">₹{order.transportationAmount ? Number(order.transportationAmount).toFixed(2) : '0.00'}</td>
              </tr>
            )}
            <tr>
              <td className="pe-3"><strong>Grand Total:</strong></td>
              <td className="text-end"><strong>₹{order.totalAmount ? Number(order.totalAmount).toFixed(2) : '0.00'}</strong></td>
            </tr>
          </tbody>
        </Table>
      </div>

      {/* Packing Material Details Section */}
      <PackingMaterialDetailsCard items={items} packingMaterials={packingMaterials} />

      {/* Upload Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{order.buyerPOAttachment ? 'Change Attachment' : 'Upload Attachment'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formFile">
              <Form.Label>Select file</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setSelectedFile(e.target.files[0])}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpload} disabled={!selectedFile}>
            Upload
          </Button>
        </Modal.Footer>
      </Modal>

      <TemporaryAllocationModal
        show={showAllocationModal}
        onHide={() => setShowAllocationModal(false)}
        item={selectedStockItem}
        so={order}
        onAllocationSaved={handleAllocationSaved}
      />

    </>
  );
}
